import { AVATARS, pickAvatarId } from "./avatars";

export default function AvatarMaker({ config, onChange }) {
  const currentId = pickAvatarId(config);
  const current = AVATARS.find((a) => a.id === currentId) || AVATARS[0];

  return (
    <div data-testid="avatar-maker">
      <div className="mb-4 flex items-center justify-center gap-5 rounded-2xl border border-ice/10 bg-navy-800/60 py-4">
        <img
          src={`/avatars/${current.id}.png`}
          alt={`${current.name} avatar`}
          data-testid="avatar-maker-preview"
          className="h-24 w-24 rounded-full object-cover ring-2 ring-magenta/70 shadow-[0_0_18px_rgba(255,43,253,0.35)]"
        />
        <div className="text-left">
          <div className="font-display text-xl font-extrabold uppercase text-cream" data-testid="avatar-maker-name">{current.name}</div>
          <button
            type="button"
            data-testid="avatar-randomize"
            onClick={() => onChange({ kind: AVATARS[Math.floor(Math.random() * AVATARS.length)].id })}
            className="mt-2 rounded-full border border-ice/25 px-4 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-mut transition-colors hover:border-amber hover:text-amber"
          >
            Surprise me
          </button>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-2" data-testid="am-kinds" role="listbox" aria-label="Characters">
        {AVATARS.map((a) => (
          <button
            key={a.id}
            type="button"
            role="option"
            aria-selected={config && config.kind === a.id}
            data-testid={`am-kind-${a.id}`}
            onClick={() => onChange({ kind: a.id })}
            className={`flex flex-col items-center gap-1 rounded-2xl p-1.5 transition-all ${config && config.kind === a.id ? "bg-magenta/15 ring-2 ring-magenta" : "ring-1 ring-ice/10 hover:ring-ice/40"}`}
          >
            <img src={`/avatars/${a.id}.png`} alt="" className="aspect-square w-full rounded-xl object-cover" />
            <span className={`font-mono text-[9px] font-bold uppercase tracking-wide ${config && config.kind === a.id ? "text-[#ff9df2]" : "text-mut"}`}>{a.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
